import {submitV2AnalyticsEvent} from "../utils/analyticsUtils";
import {initStockAvailabilityPill} from "../stock-availability-pill";
import {insertBranchSelector} from "./insertBranchSelector";
import { fetchStockAvailability } from "../stock-availability-pill/fetchStockAvailability"

export const useSelectedBranchFromLocalStorage = (userDetails) => {
    const selectedBranchLocalStorageKey = `selectedBranch_${userDetails ? userDetails.id : undefined}`
    const selectedBranchLocalStorage = localStorage.getItem(selectedBranchLocalStorageKey)
    const setSelectedBranch = (newSelectedBranch) => localStorage.setItem(selectedBranchLocalStorageKey, newSelectedBranch)

    return [
        selectedBranchLocalStorage ? JSON.parse(selectedBranchLocalStorage) : null,
        setSelectedBranch
    ]
}

export const initBranchSelector = async (win, userDetails) => {
    const hasStockAvailability = win.document.querySelector(".stock-availability-pill")
    const storeFinderWidget = win.document.querySelector('rg-max-store-finder-widget')
    const [selectedBranchInfo, setSelectedBranch] = useSelectedBranchFromLocalStorage(userDetails)
    const selectedBranch = getBranchSelectorLabelText(userDetails, selectedBranchInfo)

    if (!hasStockAvailability || !storeFinderWidget || !selectedBranch) {
        return;
    }

    const branchSelectorParent = win.document.querySelector(".product-listing-header__cat-banner")
    const branchSelector = insertBranchSelector(branchSelectorParent)
    const selectedBranchLabel = branchSelector.querySelector(".branch-selector-selected-branch-label")

    if (await isBranchSelectorEnabled(win, userDetails)) {
        selectedBranchLabel.classList.add("branch-selector-selected-branch-label-hover");
        onClickBranchSelector(branchSelector, userDetails, storeFinderWidget);
    }

    selectedBranchLabel.innerText = selectedBranch
    
    onBranchSearch(branchSelector)
    onBranchSelect(selectedBranchLabel, storeFinderWidget, setSelectedBranch, () => initStockAvailabilityPill(win, userDetails))
}

const getBranchSelectorLabelText = (userDetails, selectedBranchInfo) => {
    const homeBranch = userDetails && userDetails.HomeBranch ? userDetails.HomeBranch.name : null
    const selectedBranch = selectedBranchInfo ? selectedBranchInfo.storeName : null

    if (selectedBranch) {
        return selectedBranch
    } else if (homeBranch) {
        return `${homeBranch}`
    } else {
        return null
    }
}

const getSelectedBranchNumber = (userDetails) => {
    const [selectedBranchInfo] = useSelectedBranchFromLocalStorage(userDetails)

    if (selectedBranchInfo) {
        return selectedBranchInfo.storeCode
    } else if (userDetails && userDetails.HomeBranch) {
        return userDetails.HomeBranch.branchNumber
    } else {
        return null
    }
}

const isBranchSelectorEnabled = async (win, userDetails) => {
    const branchNumber = getSelectedBranchNumber(userDetails)
    const productTiles = win.document.querySelectorAll(".product-tile")
    const productCodes = Array.from(productTiles).map(product => product.dataset.productCode)

    if (branchNumber && productCodes) {
        try {
            const response = await fetchStockAvailability(
                branchNumber,
                productCodes
            )
            return response.showBranchSelector
        } catch(e) {
            console.log("Error while fetching stock availability")
        }
    }

    return false
}

/* eslint-disable no-unused-vars */
const onClickBranchSelector = (branchSelector, userDetails, storeFinderWidget) => {
    branchSelector.addEventListener("click", () => {
        storeFinderWidget.setAttribute("show", "true")
        storeFinderWidget.setAttribute("selected-branch-id", getSelectedBranchNumber(userDetails))
        submitV2AnalyticsEvent("viewBranchForStockInformation", {
            originID: null,
            origin: "PLP"
        });
    })
}
/* eslint-disable no-unused-vars */

const onBranchSearch = () => {
    window.addEventListener("searchBranch", (event) => {
        submitV2AnalyticsEvent("searchBranchForStockInformation", {
            originID: null,
            origin: "PLP",
            searchMethod: event.detail.searchMethod
        });
    })
}

const onBranchSelect = (selectedBranchLabel, storeFinderWidget, setSelectedBranch, updateStockAvailability) => {
    window.addEventListener("storeSelected", (event) => {
        setSelectedBranch(JSON.stringify(event.detail))
        selectedBranchLabel.innerText = event.detail.storeName
        storeFinderWidget.setAttribute("show", "false")
        updateStockAvailability()

        submitV2AnalyticsEvent("selectBranchForStockInformation", {
            originID: null,
            origin: "PLP",
            stockAvailability: "Not Applicable",
            distance: event.detail.distance,
            branchName: event.detail.storeName,
            branchID: event.detail.storeCode,
        });
    })
}